import { render, staticRenderFns } from "./setUserMaxDebt.vue?vue&type=template&id=bb22b5c4&scoped=true&"
import script from "./setUserMaxDebt.vue?vue&type=script&lang=js&"
export * from "./setUserMaxDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb22b5c4",
  null
  
)

export default component.exports